<template>
  <div>
    <div class="products-details-section__grid grid gap-4">
      <div class="contents lg:[grid-area:header] lg:flex lg:flex-col lg:gap-1">
        <div class="contents lg:flex lg:justify-between lg:gap-4">
          <SkeletonLoader
            height="100%"
            class="[grid-area:average-review] h-6 lg:h-7 lg:w-1/3 max-lg:-mb-2 max-lg:-mt-4"
          />
          <SkeletonLoader
            height="100%"
            class="[grid-area:attributes] h-6 lg:h-7 lg:w-1/2"
          />
        </div>
        <SkeletonLoader
          height="100%"
          class="[grid-area:title] h-8"
        />
      </div>
      <div class="[grid-area:gallery]">
        <div class="flex gap-2">
          <div class="hidden lg:flex flex-col gap-1">
            <SkeletonLoader
              height="42px"
              width="104px"
            />
            <SkeletonLoader
              v-for="index in 5"
              :key="index"
              height="104px"
              width="104px"
            />
            <SkeletonLoader
              height="42px"
              width="104px"
            />
          </div>
          <SkeletonLoader
            height="100%"
            class="grow h-[320px] lg:h-[500px]"
          />
        </div>
      </div>
      <div class="[grid-area:pricing]">
        <SkeletonLoader
          height="500px"
        />
      </div>
      <div class="[grid-area:details]">
        <SkeletonLoader
          height="100%"
          class="h-[450px] lg:h-[600px]"
        />
      </div>
      <div class="[grid-area:review]">
        <SkeletonLoader
          height="100px"
          class="mt-4"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ProductDetailsSectionSkeleton',
});

</script>

<style lang="scss" scoped>
@use "~/assets/scss/helpers/_breakpoints" as breakpoints;

.products-details-section {
  &__grid {
    grid-template-areas:
      "gallery"
      "title"
      "average-review"
      "pricing"
      "attributes"
      "details"
      "review";
    grid-template-columns: 100%;
  }

  @include breakpoints.for-desktop {
    &__grid {
      grid-template:
        "gallery header header" auto
        "gallery details pricing" auto
        "review details pricing" 1fr / 2fr 1fr 1fr;
    }
  }
}
</style>
